import React from 'react';
import '../styles/card.css'
import Popup from "reactjs-popup";
// import gitHub from '../assets/images/github.png';
import gitHub from '../assets/images/github.svg';


function Card (props) {
  return (
    <div className="card-container" id="id1" style={{ backgroundImage: `url(${props.project.background})` }}>
      <Popup
        trigger={<img className="project-image" alt="project" src={props.project.imgSrc}></img>}
        modal
        closeOnDocumentClick
      >
        <div className="zoom-container">
          <img className="project-image-zoom" alt="project" src={props.project.imgSrc}></img>
        </div>
      </Popup>
      <div className="text-container">
        <div className="project-title">{props.project.title}</div>
        <div className="project-description">{props.project.description}</div>

        <Popup trigger={<div className="read-more">Read more...</div>} modal onClose={props.closeModal}  onOpen={props.openModal}>
          {close => (
            <div className="modal">
              <a className="modal-close" onClick={close}>
                &times;
        </a>
              <div className="read-more-container">
                <div className="read-more-title">{props.project.title}</div>
                <div className="read-more-text">{props.project.readMore}</div>
              </div>
            </div>
          )}
        </Popup>


      </div>
      <div className="link-container">
        <a href={props.project.link} rel="noopener noreferrer" target="_blank"><button className="card-button">VISIT</button></a>
        {props.project.desktop && <div className='warning'>Not yet mobile friendly</div>}

        <a href={props.project.gitLink} rel="noopener noreferrer" target="_blank">
          <img className="card-icon" src={gitHub} alt="github" ></img>
        </a>
      </div>
    </div>
  );

}

export default Card;
